import { takeLatest, call, put } from "redux-saga/effects";
import {
  ADD_GOALS_ACHIEVED,
   ADD_GOALS_ACHIEVED_SUCCESS,
   CHECK_APPRAISAL_ENABLED_STATE,
   CHECK_APPRAISAL_ENABLED_STATE_SUCCESS,
   ENABLE_ALL_APPRAISEE,
   ENABLE_ALL_APPRAISEE_SUCCESS,
   GET_APPRAISAL_ENABLE_ADMIN_LIST,
   GET_APPRAISAL_ENABLE_ADMIN_LIST_SUCCESS,
   GET_APPRAISAL_QUESTIONS,
   GET_APPRAISAL_QUESTIONS_SUCCESS,
   GET_APPRAISEE_DETAILS,
   GET_APPRAISEE_DETAILS_SUCCESS,
   GET_APPRAISEE_PERFORMANCEGOALS,
   GET_APPRAISEE_PERFORMANCEGOALS_SUCCESS,
   GET_ATTRIBUTE_LIST,
   GET_ATTRIBUTE_LIST_SUCCESS,
   GET_BEHAVIOUR_ATTRIBUTES,
   GET_BEHAVIOUR_ATTRIBUTES_SUCCESS,
   GET_EXPERTLEVEL,
   GET_EXPERTLEVEL_SUCCESS,
   GET_GOALS_ACHIEVED,
   GET_GOALS_ACHIEVED_SUCCESS,
   GET_GOALS_BY_DESIGNATION,
   GET_GOALS_BY_DESIGNATION_SUCCESS,
   GET_PERFORMANCE_LEARNING_PLAN,
   GET_PERFORMANCE_LEARNING_PLAN_SUCCESS,
   GET_POTENTIAL_LIST,
   GET_POTENTIAL_LIST_SUCCESS,
   GET_RATING_LIST,
   GET_RATING_LIST_SUCCESS,
   GET_REVIEW_APPRAISEE_LIST,
   GET_REVIEW_APPRAISEE_LIST_SUCCESS,
   GET_TECHNICAL_CAPABILITY,
   GET_TECHNICAL_CAPABILITY_SUCCESS,
   SAVEAPPRAISEEDETAILS_SELFREVIEW,
   SAVEAPPRAISEEDETAILS_SELFREVIEW_SUCCESS,
   SAVE_BEHAVIOUR_ATTRIBUTES,
   SAVE_BEHAVIOUR_ATTRIBUTES_SUCCESS,
   SAVE_PERFORMANCEGOALS,
   SAVE_PERFORMANCEGOALS_SUCCESS,
   SAVE_PERFORMANCE_LEARNING_PLAN,
   SAVE_PERFORMANCE_LEARNING_PLAN_SUCCESS,
   SAVE_TECHNICAL_CAPABILITY,
   SAVE_TECHNICAL_CAPABILITY_SUCCESS,
   SUBMITDATA,
   SUBMITDATA_SUCCESS,
   DELETE_GOALS_ACHIEVED,
   DELETE_GOALS_ACHIEVED_SUCCESS,
   DELETE_PERFOMANCE_GOALS,
   DELETE_PERFOMANCE_GOALS_SUCCESS,
   DELETE_BEHAVIORAL_ATTRIBUTE_APPRAISAL,
   DELETE_BEHAVIORAL_ATTRIBUTE_APPRAISAL_SUCCESS,
   DELETE_TECHNICAL_CAPABILITY,
   DELETE_TECHNICAL_CAPABILITY_SUCCESS,
   GET_PERFOMANCE_GOALS,
   GET_PERFOMANCE_GOALS_SUCCESS,
  
   } from "../../redux/actions/actionType";
import api from "../../apis/api";
import { GetGoalsByDesignation } from "../../redux/actions/appraisal/appraisal.action";

// api functions.
// get all appraisal questions.
function* getAppraisalQuestionsApi() {
  const response = yield api.appraisal().getAppraisalQuestions();
  return response.data;
}
// get all expert levels.
function* getExpertLevelApi() {
  const response = yield api.appraisal().getExpertLevel();
  return response.data;
}
// get all Potential list.
function* getPotentialListApi() {
  const response = yield api.appraisal().GetPotentialsList();
  return response.data;
}
// get Appraisal Enable list.
function* GetAppraisalEnableListApi() {
  const response = yield api.appraisal().GetAppraisalEnabledAdminList();
  return response.data;
}

// get goals achieved.
function* getGoalsAchievedApi(payload) {
  const response = yield api.appraisal().GetGoalsAchievedByAppraisalId(payload);
  return response.data;
}

// get goals by designation.
function* getGoalsByDesignationApi(payload) {
  const response = yield api.appraisal().GetGoalListByDesignationId(payload);
  return response.data;
}

// get technical capability by empId.
function* getTechnicalCapabilityApi(payload) {
  const response = yield api.appraisal().GetTechinicalCapabilityByAppraiseeId(payload);
  return response.data;
}

// Check appraisal enable State by empId.
function* CheckAppraisalEnableStateApi(payload) {
  const response = yield api.appraisal().CheckAppraisalEnabledState(payload);
  return response.data;
}

// get performance learning plan by empId.
function* GetPerformanceGoalsByAppraiseeIdApi(payload) {
  const response = yield api.appraisal().GetAllPerformanceByGoalsByAppraiseeId(payload);
  return response.data;
}
// get Review appraisee List by Reviewer Id.
function* getReviewAppraiseeListApi(payload) {
  const response = yield api.appraisal().GetReviewAppraiseeListByReviewerId(payload);
  return response.data;
}

// get behaviour attributes by empId.
function* getBehaviourAttributesApi(payload) {
  const response = yield api.appraisal().GetBehaviouralAttributesByAppraiseeId(payload);
  return response.data;
}
// get performance goals by AppraiseeId.
function* getPerformanceGoalsApi(payload) {
  const response = yield api.appraisal().GetAllPerformanceByGoalsByAppraiseeId(payload);
  return response.data;
}

// get rating list.
function* getRatingListApi() {
  const response = yield api.appraisal().GetRatingList();
  return response.data;
}
// get attribute list.
function* getAttributeListApi() {
  const response = yield api.appraisal().GetAttributeList();
  return response.data;
}

// get all appraisee details.
function* GetPerformanceLearningPlanByAppraiseeIdApi(payload) {
  const response = yield api.appraisal().GetPerformanceLearningPlanByAppraiseeId(payload);
  return response.data;
}
function* getAppraiseeDetailsApi(payload) {
  const response = yield api.appraisal().getAppraiseeDetails(payload);
  return response.data;
}
//call appraisee details save api
function SaveAppraiseeDetailsApi(formData) {
  // api for add  eduinfo.
api.appraisal().SaveAppraiseeDetailsAndSelfReview(formData);
}
//call technical capability save api
function SaveTechnicalCapabilityApi(formData) {
  // api for add  eduinfo.
  api.appraisal().SaveTechinicalCapability(formData);
}

//call Submit Data api
function SubmitDataApi(formData) {
  // api for add  eduinfo.
  api.appraisal().SubmitData(formData);
}
//call Submit Data api
function EnableAllAppraiseeApi(formData) {
  // api for enable all appraisee.
  api.appraisal().EnableAllAppraisee(formData);
}

//call Behavioural attributes save api
function SaveBehaviourAttributesApi(formData) {
  // api for add  eduinfo.
  api.appraisal().SaveBehaviouralAttributes(formData);
}
//call performance learning plan save api
function SavePerformanceLearningPlanApi(formData) {
  // api for add  eduinfo.
  api.appraisal().SavePerformanceLearnningPlan(formData);
}
//call performance goals save api
function SavePerformanceGoalsApi(formData) {
  // api for add  eduinfo.
  api.appraisal().SavePerformanceByGoals(formData);
}
//call appraisee goals achieved addedit Api
function AddEditGoalsAchievedApi(formData) {
  // api for add  eduinfo.
  api.appraisal().AddEditGoalsAchieved(formData);
}
function DeleteGoalsAchievedApi(formData) {
  // api for add  eduinfo.
  api.appraisal().DeleteGoalAchieved(formData);
}
function DeletePerfomanceGoalApi(formData) {
  // api for add  eduinfo.
  api.appraisal().DeletePerfomanceGoal(formData);
}
function DeleteTechnicalCapabilityApi(formData) {
  // api for add  eduinfo.
  api.appraisal().DeleteTechnicalCapability(formData);
}
function DeleteBehaviouralattributeAppraisalApi(formData) {
  // api for add  eduinfo.
  api.appraisal().DeletePerfomanceGoal(formData);
}
// get all appraisal questions.
export function* handleGetAppraisalQuestions() {
  try {
    const response = yield call(getAppraisalQuestionsApi);

    yield put({ type: GET_APPRAISAL_QUESTIONS_SUCCESS, payload: response });
  } catch (error) {

  }
}
// get all expert levels.
export function* handleGetExpertLevel() {
  try {
    const response = yield call(getExpertLevelApi);
    yield put({ type: GET_EXPERTLEVEL_SUCCESS, payload: response });
  } catch (error) {

  }
}
// get all potentialList.
export function* handleGetPotentialList() {
  try {
    const response = yield call(getPotentialListApi);
    yield put({ type: GET_POTENTIAL_LIST_SUCCESS, payload: response });
  } catch (error) {

  }
}
export function* handleGetPerformanceLearningPlanByAppraiseeId({payload}) {
  try {
    const response = yield call(GetPerformanceLearningPlanByAppraiseeIdApi,payload);
    yield put({ type: GET_PERFORMANCE_LEARNING_PLAN_SUCCESS, payload: response });
  } catch (error) {
   
  }
}
// get goals achieved.
export function* handleGetGoalsAchieved({payload}) {
  try {
    const response = yield call(getGoalsAchievedApi,payload);
    yield put({ type: GET_GOALS_ACHIEVED_SUCCESS, payload: response });
  } catch (error) {
     
  }
}

// get goals by designation.
export function* handleGetGoalsByDesignation({payload}) {
  try {
    const response = yield call(getGoalsByDesignationApi,payload);
    yield put({ type: GET_GOALS_BY_DESIGNATION_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
// get technical capability by EmpId.
export function* handleGetTechnicalCapability({payload}) {
  try {
    const response = yield call(getTechnicalCapabilityApi,payload);
    yield put({ type: GET_TECHNICAL_CAPABILITY_SUCCESS, payload: response });
  } catch (error) {
     
  }
}

// Check Appraisal Enable State by EmpId.
export function* handleCheckAppraisalEnableState({payload}) {
  try {
    const response = yield call(CheckAppraisalEnableStateApi,payload);
    yield put({ type: CHECK_APPRAISAL_ENABLED_STATE_SUCCESS, payload: response });
  } catch (error) {
     
  }
}


// get performancr learning plan by EmpId.
export function* handleGetPerformanceGoalsByAppraiseeIdPlan({payload}) {
  try {
    const response = yield call(GetPerformanceGoalsByAppraiseeIdApi,payload);
    yield put({ type: GET_PERFOMANCE_GOALS_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
// get review appraisee List by Reviewer Id.
export function* handleGetReviewAppraiseeList({payload}) {
  try {
    const response = yield call(getReviewAppraiseeListApi,payload);
    yield put({ type: GET_REVIEW_APPRAISEE_LIST_SUCCESS, payload: response });
  } catch (error) {
     
  }
}

// get AppraisalEnable List.
export function* handleGetAppraisalEnableList() {
  try {
    const response = yield call(GetAppraisalEnableListApi);
    yield put({ type: GET_APPRAISAL_ENABLE_ADMIN_LIST_SUCCESS, payload: response });
  } catch (error) {
    //  
  }
}

// get behaviour attributes by EmpId.
export function* handleGetBehaviourAttributes({payload}) {
  try {
    const response = yield call(getBehaviourAttributesApi,payload);
    yield put({ type: GET_BEHAVIOUR_ATTRIBUTES_SUCCESS, payload: response });
  } catch (error) {
     
  }
}

// To get performance goals by AppraiseeId.
export function* handleGetPerformanceGoals({payload}) {
  try {
    const response = yield call(getPerformanceGoalsApi,payload);
    yield put({ type: GET_APPRAISEE_PERFORMANCEGOALS_SUCCESS, payload: response });
  } catch (error) {
     
  }
}


// get rating list.
export function* handleGetRatingList() {
  try {
    const response = yield call(getRatingListApi);
    yield put({ type: GET_RATING_LIST_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
// get attribute list.
export function* handleGetAttributeList() {
  try {
    const response = yield call(getAttributeListApi);
    yield put({ type: GET_ATTRIBUTE_LIST_SUCCESS, payload: response });
  } catch (error) {
     
  }
}

// get all appraisee details.
export function* handleGetAppraiseeDetails({payload}) {
  try {
    const response = yield call(getAppraiseeDetailsApi,payload);
    yield put({ type: GET_APPRAISEE_DETAILS_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
//add appraisee details
export function* handleSaveAppraiseeDetailsSelfReview({ payload }) {
  try {
    yield call(SaveAppraiseeDetailsApi, payload);
    yield put({ type: SAVEAPPRAISEEDETAILS_SELFREVIEW_SUCCESS, payload: payload });
    const response = yield call(getAppraiseeDetailsApi,payload);
    yield put({ type: GET_APPRAISEE_DETAILS_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
//add technical capability
export function* handleSaveTechnicalCapability({ payload }) {
  try {
    yield call(SaveTechnicalCapabilityApi, payload);
    yield put({ type: SAVE_TECHNICAL_CAPABILITY_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}

//submit Data
export function* handleSubmitData({ payload }) {
  try {
    yield call(SubmitDataApi, payload);
    yield put({ type: SUBMITDATA_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
//enable all appraisee
export function* handleEnableAllAppraisee({ payload }) {
  try {
    yield call(EnableAllAppraiseeApi, payload);
    yield put({ type: ENABLE_ALL_APPRAISEE_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}

//add behavioural attributes
export function* handleSaveBehaviourAttributes({ payload }) {
  try {
    yield call(SaveBehaviourAttributesApi, payload);
    yield put({ type: SAVE_BEHAVIOUR_ATTRIBUTES_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
//add performance learning plan
export function* handleSavePerformanceLearningPlan({ payload }) {
  try {
    yield call(SavePerformanceLearningPlanApi, payload);
    yield put({ type: SAVE_PERFORMANCE_LEARNING_PLAN_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}

//add performance goals
export function* handleSavePerformanceGoals({ payload }) {
  try {
    yield call(SavePerformanceGoalsApi, payload);
    yield put({ type: SAVE_PERFORMANCEGOALS_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
//add goals achieved
export function* handleAddEditGoalsAchieved({ payload }) {
  try {
    yield call(AddEditGoalsAchievedApi, payload);
    yield put({ type: ADD_GOALS_ACHIEVED_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleDeleteGoalsAchieved({ payload }) {
  try {
    yield call(DeleteGoalsAchievedApi, payload);
    yield put({ type: DELETE_GOALS_ACHIEVED_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleDeletePerfomanceGoals({ payload }) {
  try {
    yield call(DeletePerfomanceGoalApi, payload);
    yield put({ type: DELETE_PERFOMANCE_GOALS_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleDeleteTechnicalCapability({ payload }) {
  try {
    yield call(DeleteTechnicalCapabilityApi, payload);
    yield put({ type: DELETE_TECHNICAL_CAPABILITY_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleDeleteBehaviouralAttributeAppraisal({ payload }) {
  try {
    yield call(DeletePerfomanceGoalApi, payload);
    yield put({ type: DELETE_BEHAVIORAL_ATTRIBUTE_APPRAISAL_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
// appraisal watch fucntion.
export function* appraisalWatchFun() {
  yield takeLatest(GET_APPRAISAL_QUESTIONS, handleGetAppraisalQuestions);
  yield takeLatest(SAVEAPPRAISEEDETAILS_SELFREVIEW, handleSaveAppraiseeDetailsSelfReview);
  yield takeLatest(GET_APPRAISEE_DETAILS, handleGetAppraiseeDetails);
  yield takeLatest(GET_EXPERTLEVEL, handleGetExpertLevel);
  yield takeLatest(ADD_GOALS_ACHIEVED, handleAddEditGoalsAchieved);
  yield takeLatest(GET_GOALS_ACHIEVED, handleGetGoalsAchieved);
  yield takeLatest(GET_GOALS_BY_DESIGNATION, handleGetGoalsByDesignation);
  yield takeLatest(GET_RATING_LIST, handleGetRatingList);
  yield takeLatest(SAVE_PERFORMANCEGOALS, handleSavePerformanceGoals);
  yield takeLatest(GET_APPRAISEE_PERFORMANCEGOALS, handleGetPerformanceGoals);
  yield takeLatest(GET_POTENTIAL_LIST, handleGetPotentialList);
  yield takeLatest(SAVE_TECHNICAL_CAPABILITY, handleSaveTechnicalCapability);
  yield takeLatest(GET_TECHNICAL_CAPABILITY, handleGetTechnicalCapability);
  yield takeLatest(GET_ATTRIBUTE_LIST, handleGetAttributeList);
  yield takeLatest(SAVE_BEHAVIOUR_ATTRIBUTES, handleSaveBehaviourAttributes);
  yield takeLatest(GET_BEHAVIOUR_ATTRIBUTES, handleGetBehaviourAttributes);
  yield takeLatest(SAVE_PERFORMANCE_LEARNING_PLAN, handleSavePerformanceLearningPlan);
  yield takeLatest(GET_PERFOMANCE_GOALS, handleGetPerformanceGoalsByAppraiseeIdPlan);
  yield takeLatest(SUBMITDATA, handleSubmitData);
  yield takeLatest(GET_PERFORMANCE_LEARNING_PLAN,handleGetPerformanceLearningPlanByAppraiseeId)
  //review
  yield takeLatest(GET_REVIEW_APPRAISEE_LIST,handleGetReviewAppraiseeList);
  yield takeLatest(GET_APPRAISAL_ENABLE_ADMIN_LIST,handleGetAppraisalEnableList);
  yield takeLatest(ENABLE_ALL_APPRAISEE, handleEnableAllAppraisee);
  yield takeLatest(CHECK_APPRAISAL_ENABLED_STATE, handleCheckAppraisalEnableState);
  yield takeLatest(DELETE_GOALS_ACHIEVED, handleDeleteGoalsAchieved);
  yield takeLatest(DELETE_PERFOMANCE_GOALS, handleDeletePerfomanceGoals);
  yield takeLatest(DELETE_BEHAVIORAL_ATTRIBUTE_APPRAISAL, handleDeleteBehaviouralAttributeAppraisal);
  yield takeLatest(DELETE_TECHNICAL_CAPABILITY, handleDeleteTechnicalCapability);
}
